export const SET_OPEN_CALENDAR = "CALENDAR/SET_OPEN_CALENDAR";
